export const getTruncatedTextForCategory = (
  category: string,
  length: number,
): string =>
  category.length > length + 3
    ? `${category.substring(0, length)}...`
    : category;
